import React, { createContext, useContext, useState, useEffect } from 'react';
import { cosmeticIQApi } from '../service/api';
import { useNavigate } from 'react-router-dom';


export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [user,setUser] = useState(null);
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [reportResponse,setReportResponse] = useState([]);
  const [data, setData] = useState({
    industryNews: [],
    newProducts: [],
    popularProducts: [],
    stats: null,
    quickPullReports: [],
    resultCount:0,
    totalResultCount:0,
  });
    const navigate = useNavigate();
  const [newProductsCache, setNewProductsCache] = useState({
    30: { data: null, lastFetched: null, loading: false },   
    90: { data: null, lastFetched: null, loading: false },   
    180: { data: null, lastFetched: null, loading: false },  
    365: { data: null, lastFetched: null, loading: false }   
  });
   const [trendCache, setTrendCache] = useState({});

const getTrendById = async (id) => {
  const cachedData = trendCache[id];

  if (cachedData?.data && cachedData?.lastFetched) {
    return cachedData.data;
  }

  if (cachedData?.loading) {
    return new Promise((resolve, reject) => {
      const checkInterval = setInterval(() => {
        const updatedCache = trendCache[id];
        if (!updatedCache.loading) {
          clearInterval(checkInterval);
          if (updatedCache.data) {
            resolve(updatedCache.data);
          } else {
            reject(new Error('Failed to load data'));
          }
        }
      }, 100);
    });
  }

  setTrendCache(prev => ({
    ...prev,
    [id]: { ...prev[id], loading: true }
  }));

  try {
    const resp = await cosmeticIQApi.getTrendById(id);

    setTrendCache(prev => ({
      ...prev,
      [id]: {
        data: resp,
        lastFetched: Date.now(),
        loading: false
      }
    }));

    return resp;
  } catch (error) {
    if (error.status === 401) {
      setSessionExpired(true);
    }
    console.error(`Failed to fetch trend ${id}:`, error);
    setTrendCache(prev => ({
      ...prev,
      [id]: { ...prev[id], loading: false, error: error.message }
    }));
    throw error;
  }
};
    const fetchAllData = async () => {
      setLoading(true);
      
      try {
        const [news, newProds, popularProds, statsData, reports,user,trends,savedTrends,savedReports,savedViews] = await Promise.all([
          cosmeticIQApi.getIndustryNews(),
          
          cosmeticIQApi.getNewProducts('30'),
          cosmeticIQApi.getPopularProducts(),
          
          cosmeticIQApi.getStats(),
          cosmeticIQApi.getQuickPullReports(),
          cosmeticIQApi.getUserData(),
          cosmeticIQApi.getTrends(),
          cosmeticIQApi.fetchSavedTrends(),
          cosmeticIQApi.fetchSavedReports(),
          cosmeticIQApi.fetchSavedViews(),
        ]);

        setData({
          industryNews: news,
          newProducts: newProds.products || [],
          popularProducts: popularProds.products || [],
          stats: statsData,
          quickPullReports: reports,
          userData: user,
          trends:trends,
          savedTrends: savedTrends,
          savedReports: savedReports,
          savedViews: savedViews,

        });
      } catch (err) {
        if(err.status === 401) {
          setSessionExpired(true);
        }

        console.error('Failed to fetch data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    const getSegments = async () => {
      try {
         const response = await cosmeticIQApi.getSegments();
         return response.segments || [];
      } catch (err) {
        console.error('Failed to fetch segments:', err);
        throw err;
      }
    };
    const fetchNewProductsByDays = async (days, segmentId = null) => {
  const cacheKey = `${days}-${segmentId || "none"}`;
  const cachedData = newProductsCache[cacheKey];

  if (cachedData?.data && cachedData?.lastFetched) {
    return cachedData.data;
  }

  if (cachedData?.loading) {
    return new Promise((resolve, reject) => {
      const checkInterval = setInterval(() => {
        const updatedCache = newProductsCache[cacheKey];

        if (!updatedCache?.loading) {
          clearInterval(checkInterval);

          if (updatedCache?.data) {
            resolve(updatedCache.data);
          } else {
            reject(new Error("Failed to load data"));
          }
        }
      }, 100);
    });
  }

  setNewProductsCache(prev => ({
    ...prev,
    [cacheKey]: {
      ...prev[cacheKey],
      loading: true
    }
  }));

  try {
    const response = await cosmeticIQApi.getNewProducts(days, segmentId);
    const productsData = response.products || [];

    setNewProductsCache(prev => ({
      ...prev,
      [cacheKey]: {
        data: productsData,
        lastFetched: Date.now(),
        loading: false
      }
    }));

    return productsData;
  } catch (error) {
    if (error.status === 401) {
      setSessionExpired(true);
    }

    console.error(`Failed to fetch products for ${days} days:`, error);

    setNewProductsCache(prev => ({
      ...prev,
      [cacheKey]: {
        ...prev[cacheKey],
        loading: false,
        error: error.message
      }
    }));

    throw error;
  }
};
  
  



  const builderSearch = async (searchText,table) => {
    try {
      const results = await cosmeticIQApi.builderSearch(table, searchText);
      return results.ingredient || results.brand || results.category || results.group ||  [];
    } catch (err) {
      if (err.status === 401) {
        setSessionExpired(true);
      }

      console.error('Search error:', err);
      throw err;
    }
  };
  const getUserData = async() => {
    try {
      const response = await cosmeticIQApi.getUserData();
      setUser(response);
      
    } catch (err) {
      if (err.status === 401) {
        setSessionExpired(true);
      }
      console.error('Get user data error:', err);
      throw err;
    }
  };

  const builderExecute = async (report) => {
    try {
      
      const results = await cosmeticIQApi.builderExecute(report);
      
      return results;
    } catch (err) {
      if (err.status === 401) {
        setSessionExpired(true);
      }
      console.error('Builder execute error:', err);
      throw err;
    }
  };
  const login = async (data) => {
    try {
      const response = await cosmeticIQApi.login(data);
      return response;
    } catch (err) {
      console.error('login error:', err);
      throw err;
    }
  };

  const value = {
    loading,
    error,
    data,
    getTrendById,
    builderSearch,
    builderExecute,
    reportResponse,
    setReportResponse,
    isAuthenticated,setData,
    setIsAuthenticated,
    fetchAllData,sessionExpired,
    login,getUserData,
    user,setUser,
    fetchNewProductsByDays,getSegments
  };
 useEffect(() => {
  const loginTime = localStorage.getItem('loginTime');

  if (!loginTime) {
    setIsAuthenticated(false);
    setLoading(false);
    return;
  }

  const now = Date.now();
  const hoursPassed = (now - parseInt(loginTime, 10)) / (1000 * 60 * 60);

  if (hoursPassed >= 24 ) {
    localStorage.clear();
    setIsAuthenticated(false);
    navigate('/login');
  } else {
    
    setIsAuthenticated(true);
  
  }

  setLoading(false);
}, []);
useEffect(() => {
  if (!isAuthenticated) return;

  if (
    Array.isArray(data.industryNews) && data.industryNews.length === 0 &&
    Array.isArray(data.newProducts) && data.newProducts.length === 0 &&
    Array.isArray(data.popularProducts) && data.popularProducts.length === 0 &&
    data.stats === null &&
    Array.isArray(data.quickPullReports) && data.quickPullReports.length === 0
  ) {
    fetchAllData();
  }
}, [isAuthenticated]);

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};


export const useData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};